export class MaterialSituacao {

  constructor(id: number){
    this.id = id;
  }

  id: number;
  nome: string;
}
